import { useAuth } from "../../context/auth-context";
import type {
  InviteCodesListEnvelope,
  InviteCodesListPayload,
} from "./inviteCodes";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

const DEFAULT_LIMIT = 25;

export type InviteCodeListStatusFilter =
  | ""
  | "ACTIVE"
  | "USED"
  | "EXPIRED"
  | "DEACTIVATED";

export type UseInviteCodesQueryParams = {
  page: number;
  limit?: number;
  search?: string;
  /** Omit or "" for all statuses. */
  status?: InviteCodeListStatusFilter;
  enabled?: boolean;
};

export function useInviteCodesQuery(params: UseInviteCodesQueryParams) {
  const { isAuthenticated } = useAuth();
  const {
    page,
    limit = DEFAULT_LIMIT,
    search,
    status = "",
    enabled: enabledParam = true,
  } = params;

  return useApiQuery<InviteCodesListEnvelope, InviteCodesListPayload>({
    queryKey: apiQueryKey("invite-codes", {
      page,
      limit,
      search: search?.trim() || null,
      status: status || null,
    }),
    url: "api/invite-codes",
    params: {
      page,
      limit,
      search: search?.trim() || undefined,
      status: status || undefined,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
